import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './Fieldset.module.scss.js';
import { Legend } from './Legend.js';

const { componentTestLabel } = getTestLabels('Fieldset');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Form/Fieldset/Fieldset.tsx)
 *
 * Use a `<Fieldset>` to semantically group multiple related form elements. This maps to a regular HTML `fieldset` ([MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/fieldset)).
 * Especially useful for groups of radio buttons or checkboxes, or for sub-sections of forms.
 *
 * If a `legendText` prop is provided, it will be rendered as an HTML `<legend>`.
 *
 * @param {string} legendPosition - (optional) **DEPRECATED (will be removed in a future version)** One of `normal` (default) or `side`. Passed to the `Legend` component to control its text-align.
 * @param {string} legendText - (optional) If provided, will render as an HTML `<legend>` as the first child of the `<fieldset>`.
 */
const Fieldset = forwardRef((props, ref) => {
    const { children, className, legendPosition, legendText, ...otherProps } = props;
    return (jsxs("fieldset", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-fieldset'], className), children: [legendText && (jsx(Legend, { legendPosition: legendPosition, children: legendText })), children] }));
});
Fieldset.displayName = 'Fieldset';

export { Fieldset };
//# sourceMappingURL=Fieldset.js.map
